import { Component, OnInit } from '@angular/core';
import { LanguageService } from './core/services/language.service';
import { AuthenticationService } from './core/services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor (private languageService: LanguageService,
               private authService: AuthenticationService) {}

  ngOnInit () {
    this.languageService.activate();
    this.authService.activate();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/app.component.ts